module.exports = __webpack_public_path__ + "img/New PACI Flow - New-6.008f2293.png";